import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import Label from 'components/form/Label/Label';
import './OneClickApplicationModuleView.scss';
import OneClickApplicationPersonalInfoModal from 'partial/OneClickApplicationPersonalInfoModal/OneClickApplicationPersonalInfoModal';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import CardOfferInfoBlock from 'partial/OneClickApplication/components/cardOfferInfoBlock';
import PersonalInfoBlock from 'partial/OneClickApplication/components/personalInfoBlock';
import FinancialInformationBlock from 'partial/OneClickApplication/components/financialInformationBlock';

const OneClickApplicationModuleView = props => {
  const {
    personalInfo,
    userInfo,
    ssnForm,
    showEditModal,
    onChangeEditModal,
    postCustomerInfoToPreApprovalOneClick,
    employmentStatus,
    employmentStatusError,
    workPhone,
    workPhoneError,
    totalAnnualIncome,
    totalAnnualIncomeError,
    monthlyRent,
    monthlyRentError,
    bankAccountType,
    bankAccountTypeError,
    residence,
    residenceError,
    totalBalanceOfAccounts,
    totalBalanceOfAccountsError,
    ifOffered,
    ifOfferedError,
    isUsCitizen,
    isUsCitizenError,
    country,
    countryError,
    motherMaidenName,
    motherMaidenNameError,
    isCheckedTerms,
    isCheckedTermsError,
    setPersonalInfo,
    oneClickApplicationOffer,
    onMouseClickDetails,
    onClickPricingAndTerms,
    onClickPrivacyPoliciy,
    onClickBankDisclaimers,
    onClickBankSecurity,
    oneClickApplicationconfig,
    setState,
    ssnError,
    onChangeTotalAnnualIncome,
    onChangeMonthlyRent,
    onChangeMotherMaidenName,
    phoneNumberStateList,
    quantityUserPhones,
    setQuantityUserPhones,
  } = props;

  const {
    employmentList,
    chooseResidenceList,
    chooseInterestedList,
    bankAccountTypeList,
    totalBalanceList,
    chooseUsaCitizienList,
    countryList,
    termsAndConditions,
  } = oneClickApplicationconfig;

  return (
    <SectionContainer className="bgGrey005 m-bgPurpleGradient">
      <TitleContainer
        fullWidth
        type="pageTitle"
        className="marketplace-header m-hide"
      >
        <Label type="H1" typeHeader={'h1'}>
          Offer Application
        </Label>
        <PrivacyPolicyLink
          className="otherLink text-14 fontBlue100 underline flex-container justify-end"
          onClick={onClickPrivacyPoliciy}
        />
      </TitleContainer>
      <Row>
        <PrivacyPolicyLink
          className="otherLink text-14 fontWhite d-hide underline flex-container justify-end"
          onClick={onClickPrivacyPoliciy}
        />
        <CardOfferInfoBlock
          oneClickApplicationOffer={oneClickApplicationOffer}
          onMouseClickDetails={onMouseClickDetails}
        />
      </Row>
      <Row className="m-bgWhite m-customBorderRow">
        <PersonalInfoBlock
          userInfo={userInfo}
          personalInfo={personalInfo}
          onChangeEditModal={onChangeEditModal}
          ssnForm={ssnForm}
          ssnError={ssnError}
          phoneNumberStateList={phoneNumberStateList}
          quantityUserPhones={quantityUserPhones}
          setQuantityUserPhones={setQuantityUserPhones}
        />
      </Row>
      <Row className="m-bgWhite m-padt30 padB40 m-padB20">
        <FinancialInformationBlock
          employmentList={employmentList}
          chooseResidenceList={chooseResidenceList}
          chooseInterestedList={chooseInterestedList}
          chooseUsaCitizienList={chooseUsaCitizienList}
          postCustomerInfoToPreApprovalOneClick={
            postCustomerInfoToPreApprovalOneClick
          }
          bankAccountTypeList={bankAccountTypeList}
          totalBalanceList={totalBalanceList}
          countryList={countryList}
          workPhone={workPhone}
          workPhoneError={workPhoneError}
          totalAnnualIncome={totalAnnualIncome}
          totalAnnualIncomeError={totalAnnualIncomeError}
          residence={residence}
          residenceError={residenceError}
          totalBalanceOfAccounts={totalBalanceOfAccounts}
          totalBalanceOfAccountsError={totalBalanceOfAccountsError}
          ifOffered={ifOffered}
          ifOfferedError={ifOfferedError}
          isUsCitizen={isUsCitizen}
          isUsCitizenError={isUsCitizenError}
          employmentStatus={employmentStatus}
          employmentStatusError={employmentStatusError}
          monthlyRent={monthlyRent}
          monthlyRentError={monthlyRentError}
          bankAccountType={bankAccountType}
          bankAccountTypeError={bankAccountTypeError}
          country={country}
          countryError={countryError}
          motherMaidenName={motherMaidenName}
          motherMaidenNameError={motherMaidenNameError}
          isCheckedTerms={isCheckedTerms}
          isCheckedTermsError={isCheckedTermsError}
          onClickPricingAndTerms={onClickPricingAndTerms}
          onClickPrivacyPoliciy={onClickPrivacyPoliciy}
          onClickBankDisclaimers={onClickBankDisclaimers}
          onChangeTotalAnnualIncome={onChangeTotalAnnualIncome}
          onChangeMonthlyRent={onChangeMonthlyRent}
          onChangeMotherMaidenName={onChangeMotherMaidenName}
          onClickBankSecurity={onClickBankSecurity}
          termsAndConditions={termsAndConditions}
          setState={setState}
        />
      </Row>
      <OneClickApplicationPersonalInfoModal
        visible={showEditModal}
        onCloseClick={() => onChangeEditModal(false)}
        personalInfo={personalInfo}
        userInfo={userInfo}
        setPersonalInfo={setPersonalInfo}
        {...props}
      />
    </SectionContainer>
  );
};

const PrivacyPolicyLink = ({ className, onClick }) => (
  <Label className={className} onClick={onClick}>
    Privacy Policy
  </Label>
);

export default OneClickApplicationModuleView;
